module.exports = __webpack_public_path__ + "static/media/3.24.3f573719.png";